import { Icon, Loader } from '@sloyd/ui';
import classnames from 'classnames';
import { Extra, Prompt, Running, Wrapper } from './EditorCommandsQueueRow.style';

export type EditorCommandQueueRowProps = {
  command: IEditorCommand;
};

const iconsMap: Record<string, string> = {
  soda: 'IconBeer', // Drink icon
  textaco: 'IconBrush', // Creative / artistic
  nog: 'IconAdjustments', // Generic tweak/settings
  environment: 'IconTree', // Nature/environment
  randomize: 'IconDice6', // Random/dice
  download: 'IconDownload', // Download arrow
  'style-transfer': 'IconTransfer', // Transfer/process
  'add-model': 'IconPlus', // Add/plus
};

const statusMap: any = {
  pending: ' ',
  running: ' ',
  success: '✅',
  error: '❌',
};

export function EditorCommandQueueRow(props: EditorCommandQueueRowProps) {
  const { command } = props;
  const { params, status, isArchived } = command;
  const { prompt, message } = params ?? {};

  const iconName = iconsMap[command.type] || 'IconAdjustments';
  const emoji = statusMap[status];

  const className = classnames('EditorCommandQueueRow-wrapper', status, {
    archived: isArchived,
  });

  return (
    <Wrapper className={className} data-testid='EditorCommandQueueRow-wrapper'>
      <Icon name={iconName} color='#eee' />
      <Prompt className='prompt'>{message || prompt}</Prompt>
      <Extra>
        {emoji}
        {status === 'running' && (
          <Running>
            <Loader size={18} color='gold' />
          </Running>
        )}
      </Extra>
    </Wrapper>
  );
}

export default EditorCommandQueueRow;
